module.exports = __webpack_public_path__ + "img/payment-paysafe.d86b5c9a.svg";